export const ukPhoneMask = '+44 #### ### ###';

export const formatPhoneWithMask = (phone) => {
    if (!phone) return null;

    if (phone.startsWith('+44') && phone.length >= 12) {
        const parts = [
            phone.substring(0, 3),
            phone.substring(3, 7),
            phone.substring(7, 10),
            phone.substring(10, Math.min(phone.length, 13))
        ];

        return parts.join(' ');
    }

    return phone;
};
